import { AddonLfImageModel } from '@/components/addons/lf-image/Model';
import { SdkTypeCheck } from '@/sdk/utilities';
import { SdkBaseAddonModel } from '.';

export class SdkAddonImage extends SdkBaseAddonModel {
  #model: AddonLfImageModel;

  constructor(model: AddonLfImageModel) {
    super(model);
    this.#model = model;
  }

  get source(): string | undefined {
    return this.#model.state.src;
  }
  set source(value: string | undefined) {
    try {
      SdkTypeCheck('string', value);
      this.#model.state.src = value;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
  get alt(): string | undefined {
    return this.#model.state.altText;
  }
  set alt(value: string | undefined) {
    try {
      SdkTypeCheck('string', value);

      this.#model.state.altText = value;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
